import { render, staticRenderFns } from "./FiflFooter.vue?vue&type=template&id=65991971"
import script from "./FiflFooter.vue?vue&type=script&lang=js"
export * from "./FiflFooter.vue?vue&type=script&lang=js"
import style0 from "./FiflFooter.vue?vue&type=style&index=0&id=65991971&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports